import imgSrc from '../javascripts/imgSrc'
let en = {
    postureHome:{
        indexPage: {
            a_posture_title: "Posture Report",
            show: "1"
        },
        coverInfo: {
            customerName: "Test Subject",
            date: "Test Date",
            time: "Test time",
            userName: "Test analyst",
            clickEnterReport: "click enter report"
        },
    },
    postureIpad: {
        bullet: {
            Home: "Home",
            Posturedata: 'Posture data',
            Score: 'Risk Assessment',
            Muscle: 'Muscular Assessment',
            Solution: 'Solution'
        },
        front: 'front',
        side: 'side',
        viwesNav: 'Side | Front',
        InvalidData: 'Invalid Report',
        qrcode: 'Send us Email unlock your excerise',
        expertsWalk: 'Senno Posture',
        smallProgram: 'support@sennotech.com',
        clickRightTop: 'Click the button on top right corner',
        clickTranspond: 'click to share the mini program',
        symptoms: {
            head: [
                {
                    name: 'Head Tilt',
                    key: 'headSidesway',
                    normal: {
                        left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
                        right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
                        normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
                        right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
                    },
                    definition: '在直立过程中，头部向左或右倾斜的现象。',
                    harm: {
                        bone: '颈椎侧屈',
                        muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
                        neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
                        des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
                    },
                    risks: [
                        {
                            name: 'Chronic Muscle and Ligament Strain',
                            des: 'Prolonged cephalic tilt or torticollis may lead to chronic strain of the posterior cervical ligament and surrounding muscles. '
                        },
                        {
                            name: 'Cervical Spondylosis',
                            des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often attributed to constantly working against gravity to balance your head on your torso.Abnormal position of soft tissue and bones from an ectopic head increases the risk of painful degeneration of the intervertebral discs'
                        }
                    ]
                },
                {
                    name: 'Head Forward',
                    key: 'headLean',
                    normal: {
                        normal: imgSrc.risk_normal.HEAD_LEAN
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.HEAD_LEAN
                    },
                    definition: '头部过度向前伸的现象。',
                    harm: {
                        bone: '椎弓变直或出现反弓',
                        muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
                        neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
                        des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
                    },
                    risks: [
                        {
                            name: 'Dizziness and Headaches',
                            des: 'Brain hypoxia caused by poor circulation arising from posture with the head forward may lead to dizziness and headaches.'
                        },
                        {
                            name: 'Cervical Spondylosis',
                            des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often attributed to constantly working against gravity to balance your head on your torso.Abnormal position of soft tissue and bones from an ectopic head increases the risk of painful degeneration of the intervertebral discs'
                        },
                        // {
                        //   name: '腰椎不稳',
                        //   des: 'Abnormal cervical stress and resultant degeneration of intervertebral discs caused by forward head posture could stress the entire spine.'
                        // },
                        // {
                        //   name: 'Cardiovascular Disease',
                        //   des: 'Abnormal posture can affect brain blood circulation.'
                        // }
                    ]
                }
            ],
            shoulder: [
                {
                    name: 'Uneven Shoulders',
                    key: 'highLowShoulder',
                    normal: {
                        left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                        right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                        normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                        right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                    },
                    definition: '肩峰左右高度差超过2CM则为高低肩。',
                    harm: {
                        bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
                        muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
                        neurovascular: '',
                        des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
                    },
                    risks: [
                        {
                            name: 'Chronic Headaches',
                            des: 'Uneven shoulders may eventually lead to chronic headaches.'
                        },
                        {
                            name: 'Bone Spurs',
                            des: 'Shoulders that are not level generate abnormal force on the neck, making a person prone to degeneration of the cervical spine and in some cases bone spurs. '
                        },
                        {
                            name: 'Lumbago',
                            des: 'Slanted shoulders may cause lateral pelvis tilt, waist muscle imbalance, and lumbago.'
                        },
                        {
                            name: 'Leg Length Discrepancy',
                            des: 'Pelvic side-tilt also increases the risk of an apparent inequality in the length of legs.'
                        }
                    ]
                },
                {
                    name: 'Rounded Shoulders',
                    key: 'roundShoulder',
                    normal: {
                        normal: imgSrc.risk_normal.ROUND_SHOULDER
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.ROUND_SHOULDER
                    },
                    definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
                    harm: {
                        bone: '肩胛骨外展、胸廓变小',
                        muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
                        neurovascular: '',
                        des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
                    },
                    risks: [
                        {
                            name: 'Cardiovascular Disease',
                            des: ' Rounded shoulders make the diaphragm tense up, increasing the risk of cardiovascular disease.'
                        },
                        {
                            name: 'Headaches',
                            des: 'Neck and shoulder tension that rounds the shoulders can even cause cervical nerve compression and headaches.'
                        },
                        {
                            name: 'Numb Arms',
                            des: 'Cervical nerve compression can also bring on numbness or paresthesia of the arms.'
                        }
                    ]
                }
            ],
            trunk: [
                {
                    name: 'Scoliosis',
                    key: 'spineSidesway',
                    normal: {
                        left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
                        right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
                        normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
                        right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
                    },
                    definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
                    harm: {
                        bone: '脊柱出现S型弯曲或C型弯曲',
                        muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
                        neurovascular: '',
                        des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
                    },
                    risks: [
                        {
                            name: 'Scoliosis',
                            des: 'Further 3-D inspection is indicated to diagnose scoliosis.'
                        },
                        {
                            name: 'Uneven Shoulders',
                            des: 'Scoliosis may be accompanied by uneven shoulders.'
                        },
                        {
                            name: 'Uneven Hips',
                            des: 'Scoliosis may be accompanied by uneven hips.'
                        }
                    ]
                }
            ],
            pelvis: [
                {
                    name: 'Uneven Hips',
                    key: 'pelvisLean',
                    normal: {
                        left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
                        right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
                        normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
                        right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT,
                    },
                    definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
                    harm: {
                        bone: '骨盆倾斜',
                        muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
                        neurovascular: '',
                        des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
                    },
                    risks: [
                        {
                            name: 'Chronic Pain',
                            des: 'Uneven hips may cause extremity pain.'
                        },
                        {
                            name: 'Lumbar Disc Herniation',
                            des: 'Uneven hips may increase the risk of lumbar disc herniation.'
                        },
                        {
                            name: 'Leg Length Discrepency',
                            des: 'Uneven hips may increase the risk of leg length discrepancy.'
                        }
                    ]
                }
            ],
            'lower extremity': [
                {
                    name: 'Bow Legs (O-shaped Curvature)',
                    key: 'legO',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_O
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_O
                    },
                    definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
                    harm: {
                        bone: 'O型腿（膝内翻）',
                        muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
                        neurovascular: '',
                        des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
                    },
                    risks: [
                        {
                            name: 'Meniscus Injury',
                            des: 'The force on the lower limb of bow-legged individuals is altered so that '
                        },
                        {
                            name: 'Arthritis',
                            des: 'Severe bow legs may eventually progress to osteoarthritis on the lateral interstitial space of the joint.'
                        }
                    ]
                },
                {
                    name: 'Genu Valgum (Knock Knees)',
                    key: 'legX',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_X
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_X
                    },
                    definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
                    harm: {
                        bone: 'X型腿（膝外翻）',
                        muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
                        neurovascular: '',
                        des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
                    },
                    risks: [
                        {
                            name: 'Meniscus Injury',
                            des: 'Because knock knees alter the direction of force on the lower limb, the knee is subject to increased lateral pressure. Lateral meniscus strain and injury often result.'
                        },
                        {
                            name: 'Arthritis',
                            des: 'Severe genu valgum may eventually progress to osteoarthritis.'
                        }
                    ]
                },
                {
                    name: 'Back Knee',
                    key: 'kneeOverstretch',
                    normal: {
                        normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
                    },
                    definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
                    harm: {
                        bone: '踝关节背屈不足，使膝关节无法向前移动',
                        muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
                        neurovascular: '',
                        des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
                    },
                    risks: [
                        {
                            name: 'Knee Joint Degeneration',
                            des: 'Excessive wear and degeneration of the knee is the result of persistent back knee.'
                        },
                        {
                            name: 'Body balance influence',
                            des: 'Deformed knees lead to position changes of the hips, pelvis, and ankles, and can gradually modify the balance of the whole body.'
                        }
                    ]
                },
                {
                    name: 'False Bow Legs',
                    key: 'legXO',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_XO
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_XO
                    },
                    definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
                    harm: {
                        bone: '这个是XO型腿',
                        muscle: '这个是XO型腿',
                        neurovascular: '',
                        des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
                    },
                    risks: [
                        {
                            name: 'Knee pain',
                            des: 'When the pelvic tilts forward, it creates a “grid” misalignment at the knee joint as well. Your femur now doesn’t track properly over your tibia (shin bone), creating an imbalance.When imbalance is paired with internally rotated femurs (due to a lack of strong glutes because of APT), you end up with a perfect recipe for false curvature knees.\n' +
                                'you may hear your knee popping and cracking quite often while moving around throughout your day. '
                        },
                        {
                            name: 'Arthritis',
                            des: 'As time progresses, you may start feeling pain since the stabilizing structures (ie. cartilage and ligaments) in the knee get wore down at a much faster rate compared to a neutral knee.'
                        }
                    ]
                }
            ],
        }
    },
    postureModalIpad: {
        detection: "Detected",
        item: "items",
        noHeightRisk: "You have very healthy posture, Keep going!",
        otherDetecation: "other items",
        potentialRisk: "Mid risk",
        heightRisk: "High risk",
        suggest: "Your posture needs to improve, a few minutes a day of posture excerise will be very helpful ",
        suggestSolve: "You really need to improve your posture, please find chiropractors or Physio therpist make more evaluation",
        normal: "Normal",
        risk: "Risk",
        return: "return",
        levelName: "High | Mid | Low"
    },
    postureModal: {
        goback: "Back",
        normal: "Normal",
        highRisk: "High Risk",
        potentialRisk: "Mid Risk",
        levelName: "High | Mid | Low",
        symptominterpretation: "Tips",
        triggersymptoms: "Impacts"
    },
    postureReport: {
        redAlert: "Red zone stands for muscle tension",
        yellowAlert: "Yellow zone stands for muscle weakness",
        muscleDire: {
            normal: "Normal",
            face: "Front",
            side: "Side",
            back: "Back"
        },
        details: {
            lh: "lh",
            ll: "ll",
            rh: "rh",
            rr: "rr"
        },
        descripName: {
            upName: "needs to be strengthened",
            lowName: "needs to be stretched "
        },
        navList: "Front | Side | Back",
        boneDescription: {
            face: {
                trunk: "Abdominal muscles",
                legForX: ["Hip abductor muscles", "Hip adductor muscles"],
                legForO: "Hip abductor muscles",
                legForStretch: "Quadriceps femoris",
                round: "Qectoralis major"
            },
            side: {
                round: "Sternocleidomastoid muscle",
                fore: "Sternocleidomastoid muscle",
                shoulder: "Scalene mucscle"
            },
            back: {
                spine: "Upper traps",
                shoulder: "Upper traps",
                round: ["Upper traps", "Lower traps"],
                fore: ["Upper traps", "Lower traps"],
                rake: "Levator scapulae",
                legStretch: ["Hamstring muscles", "Plantar fascia"],
                legX: ['Hip abductor muscles', 'Biceps Femoris'],
                legO: ['Hamstrings', 'Tibialis Anterior， Tibialis Posterior'],
                legXO: ['Biceps Femoris', 'Plantar fascia']
            }
        }
    },
    postureSymp: {
        detection: 'Detected',
        item: 'items',
        noHeightRisk: 'You have very healthy posture, Keep going!',
        otherDetecation: 'other items',
        potentialRisk: 'Mid risk',
        heightRisk: 'High risk',
        suggest: 'Your posture needs to improve, a few minutes a day of posture excerise will be very helpful ',
        suggestSolve: 'You really need to improve your posture, please find chiropractors or Physio therpist make more evaluation',
        normal: 'Normal',
        risk: 'Risk',
    },
    postureSympIpad: {
        detection: "Detected",
        item: "items",
        noHeightRisk: "You have very healthy posture, Keep going!",
        otherDetecation: "other items",
        potentialRisk: "Mid risk",
        heightRisk: "High risk",
        suggest: "Your posture needs to improve, a few minutes a day of posture excerise will be very helpful ",
        suggestSolve: "You really need to improve your posture, please find chiropractors or Physio therpist make more evaluation",
        normal: "Normal",
        risk: "Risk"
    },
    posture: {
        bullet: {
            Home: "Home",
            Posturedata: 'Posture data',
            Score: 'Risk Assessment',
            Muscle: 'Muscular Assessment',
            Solution: 'Solution'
        },

        viwesNav: 'Side | Front',
        InvalidData: 'Invalid Report',
        qrcode: 'Send us Email unlock your excerise',
        expertsWalk: 'Senno Posture',
        smallProgram: 'support@sennotech.com',
        clickRightTop: 'Click the button on top right corner',
        clickTranspond: 'click to share the mini program',
        symptoms: {
            head: [
                {
                    name: 'Head Tilt',
                    key: 'headSidesway',
                    normal: {
                        left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
                        right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
                        normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
                        right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
                    },
                    definition: '在直立过程中，头部向左或右倾斜的现象。',
                    harm: {
                        bone: '颈椎侧屈',
                        muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
                        neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
                        des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
                    },
                    risks: [
                        {
                            name: 'Chronic Muscle and Ligament Strain',
                            des: 'Prolonged cephalic tilt or torticollis may lead to chronic strain of the posterior cervical ligament and surrounding muscles. '
                        },
                        {
                            name: 'Cervical Spondylosis',
                            des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often attributed to constantly working against gravity to balance your head on your torso.Abnormal position of soft tissue and bones from an ectopic head increases the risk of painful degeneration of the intervertebral discs'
                        }
                    ]
                },
                {
                    name: 'Head Forward',
                    key: 'headLean',
                    normal: {
                        normal: imgSrc.risk_normal.HEAD_LEAN
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.HEAD_LEAN
                    },
                    definition: '头部过度向前伸的现象。',
                    harm: {
                        bone: '椎弓变直或出现反弓',
                        muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
                        neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
                        des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
                    },
                    risks: [
                        {
                            name: 'Dizziness and Headaches',
                            des: 'Brain hypoxia caused by poor circulation arising from posture with the head forward may lead to dizziness and headaches.'
                        },
                        {
                            name: 'Cervical Spondylosis',
                            des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often attributed to constantly working against gravity to balance your head on your torso.Abnormal position of soft tissue and bones from an ectopic head increases the risk of painful degeneration of the intervertebral discs'
                        },
                        // {
                        //   name: '腰椎不稳',
                        //   des: 'Abnormal cervical stress and resultant degeneration of intervertebral discs caused by forward head posture could stress the entire spine.'
                        // },
                        // {
                        //   name: 'Cardiovascular Disease',
                        //   des: 'Abnormal posture can affect brain blood circulation.'
                        // }
                    ]
                }
            ],
            shoulder: [
                {
                    name: 'Uneven Shoulders',
                    key: 'highLowShoulder',
                    normal: {
                        left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                        right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                        normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                        right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                    },
                    definition: '肩峰左右高度差超过2CM则为高低肩。',
                    harm: {
                        bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
                        muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
                        neurovascular: '',
                        des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
                    },
                    risks: [
                        {
                            name: 'Chronic Headaches',
                            des: 'Uneven shoulders may eventually lead to chronic headaches.'
                        },
                        {
                            name: 'Bone Spurs',
                            des: 'Shoulders that are not level generate abnormal force on the neck, making a person prone to degeneration of the cervical spine and in some cases bone spurs. '
                        },
                        {
                            name: 'Lumbago',
                            des: 'Slanted shoulders may cause lateral pelvis tilt, waist muscle imbalance, and lumbago.'
                        },
                        {
                            name: 'Leg Length Discrepancy',
                            des: 'Pelvic side-tilt also increases the risk of an apparent inequality in the length of legs.'
                        }
                    ]
                },
                {
                    name: 'Rounded Shoulders',
                    key: 'roundShoulder',
                    normal: {
                        normal: imgSrc.risk_normal.ROUND_SHOULDER
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.ROUND_SHOULDER
                    },
                    definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
                    harm: {
                        bone: '肩胛骨外展、胸廓变小',
                        muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
                        neurovascular: '',
                        des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
                    },
                    risks: [
                        {
                            name: 'Cardiovascular Disease',
                            des: ' Rounded shoulders make the diaphragm tense up, increasing the risk of cardiovascular disease.'
                        },
                        {
                            name: 'Headaches',
                            des: 'Neck and shoulder tension that rounds the shoulders can even cause cervical nerve compression and headaches.'
                        },
                        {
                            name: 'Numb Arms',
                            des: 'Cervical nerve compression can also bring on numbness or paresthesia of the arms.'
                        }
                    ]
                }
            ],
            trunk: [
                {
                    name: 'Scoliosis',
                    key: 'spineSidesway',
                    normal: {
                        left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
                        right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
                        normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
                        right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
                    },
                    definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
                    harm: {
                        bone: '脊柱出现S型弯曲或C型弯曲',
                        muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
                        neurovascular: '',
                        des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
                    },
                    risks: [
                        {
                            name: 'Scoliosis',
                            des: 'Further 3-D inspection is indicated to diagnose scoliosis.'
                        },
                        {
                            name: 'Uneven Shoulders',
                            des: 'Scoliosis may be accompanied by uneven shoulders.'
                        },
                        {
                            name: 'Uneven Hips',
                            des: 'Scoliosis may be accompanied by uneven hips.'
                        }
                    ]
                }
            ],
            pelvis: [
                {
                    name: 'Uneven Hips',
                    key: 'pelvisLean',
                    normal: {
                        left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
                        right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
                        normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
                        right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT,
                    },
                    definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
                    harm: {
                        bone: '骨盆倾斜',
                        muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
                        neurovascular: '',
                        des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
                    },
                    risks: [
                        {
                            name: 'Chronic Pain',
                            des: 'Uneven hips may cause extremity pain.'
                        },
                        {
                            name: 'Lumbar Disc Herniation',
                            des: 'Uneven hips may increase the risk of lumbar disc herniation.'
                        },
                        {
                            name: 'Leg Length Discrepency',
                            des: 'Uneven hips may increase the risk of leg length discrepancy.'
                        }
                    ]
                }
            ],
            'lower extremity': [
                {
                    name: 'Bow Legs (O-shaped Curvature)',
                    key: 'legO',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_O
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_O
                    },
                    definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
                    harm: {
                        bone: 'O型腿（膝内翻）',
                        muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
                        neurovascular: '',
                        des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
                    },
                    risks: [
                        {
                            name: 'Meniscus Injury',
                            des: 'The force on the lower limb of bow-legged individuals is altered so that '
                        },
                        {
                            name: 'Arthritis',
                            des: 'Severe bow legs may eventually progress to osteoarthritis on the lateral interstitial space of the joint.'
                        }
                    ]
                },
                {
                    name: 'Genu Valgum (Knock Knees)',
                    key: 'legX',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_X
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_X
                    },
                    definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
                    harm: {
                        bone: 'X型腿（膝外翻）',
                        muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
                        neurovascular: '',
                        des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
                    },
                    risks: [
                        {
                            name: 'Meniscus Injury',
                            des: 'Because knock knees alter the direction of force on the lower limb, the knee is subject to increased lateral pressure. Lateral meniscus strain and injury often result.'
                        },
                        {
                            name: 'Arthritis',
                            des: 'Severe genu valgum may eventually progress to osteoarthritis.'
                        }
                    ]
                },
                {
                    name: 'genu recurvatum',
                    key: 'kneeOverstretch',
                    normal: {
                        normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
                    },
                    definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
                    harm: {
                        bone: '踝关节背屈不足，使膝关节无法向前移动',
                        muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
                        neurovascular: '',
                        des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
                    },
                    risks: [
                        {
                            name: 'Knee Joint Degeneration',
                            des: 'Excessive wear and degeneration of the knee is the result of persistent back knee.'
                        },
                        {
                            name: 'Body balance influence',
                            des: 'Deformed knees lead to position changes of the hips, pelvis, and ankles, and can gradually modify the balance of the whole body.'
                        }
                    ]
                },
                {
                    name: 'False Bow Legs',
                    key: 'legXO',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_XO
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_XO
                    },
                    definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
                    harm: {
                        bone: '这个是XO型腿',
                        muscle: '这个是XO型腿',
                        neurovascular: '',
                        des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
                    },
                    risks: [
                        {
                            name: 'Knee pain',
                            des: 'When the pelvic tilts forward, it creates a “grid” misalignment at the knee joint as well. Your femur now doesn’t track properly over your tibia (shin bone), creating an imbalance.When imbalance is paired with internally rotated femurs (due to a lack of strong glutes because of APT), you end up with a perfect recipe for false curvature knees.\n' +
                                'you may hear your knee popping and cracking quite often while moving around throughout your day. '
                        },
                        {
                            name: 'Arthritis',
                            des: 'As time progresses, you may start feeling pain since the stabilizing structures (ie. cartilage and ligaments) in the knee get wore down at a much faster rate compared to a neutral knee.'
                        }
                    ]
                }
            ],
        }
    },
    sympItem: {
        levelName: "height | middle | lower"
    },
    sympItemIpad: {
        detection: "Detected",
        item: "items",
        noHeightRisk: "You have very healthy posture, Keep going!",
        otherDetecation: "other items",
        potentialRisk: "Mid risk",
        heightRisk: "High risk",
        suggest: "Your posture needs to improve, a few minutes a day of posture excerise will be very helpful ",
        suggestSolve: "You really need to improve your posture, please find chiropractors or Physio therpist make more evaluation",
        normal: "Normal",
        risk: "Risk",
        levelName: "High | Mid | Low"
    }


}
export {
    en
}



// WEBPACK FOOTER //
// ./src/assets/lang.conf/en.js